import { useSelector, useDispatch } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { logout } from '../../redux/actions';

function Navbar() {

  let location=useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const tipoCurrentUser = useSelector((state) => state.tipoCurrentUser);

  const navBarSuperAdmin= ['inicio', 'vehiculos', 'usuarios', 'licencias', 'salir']
  const navBarUser= ['inicio', 'vehiculos', 'licencias', 'salir']

  const elementosNavBar= tipoCurrentUser === 'super_admin'? navBarSuperAdmin : navBarUser

  const handleSalir = (e) => {
    e.preventDefault();
    dispatch(logout());
    navigate("/");
  };
    

  return (

    <div style={{
        width: '100%',
        height: '100%',
        alignItems: 'center',
        display: 'flex',
        
        }}>      
        {elementosNavBar.map((path, index, array) => {
        // Determina si la ruta actual coincide con el enlace
        const isActive = location.pathname === `/${path}`;
        
        
        return (
        <Link to={`/${path}`} key={index} style={{ flex: 1 }} onClick={path === 'salir' ? handleSalir : undefined}>
          <div className={`h-[105px] py-5 ${
                isActive ? 'bg-[#0a5477]' : 'bg-[#0477AD]'
              } flex justify-center items-center box-border ${
                index !== array.length - 1 ? 'border-r border-white' : ''
              }`}
           >
            <div class="text-white sm:text-[1.5rem] text-[1rem] font-inter font-bold break-words">
              {path.charAt(0).toUpperCase() + path.slice(1)}
            </div>
          </div>
        </Link>
      )})}
    </div>



  );
}

export default Navbar;

